<template>
  <div style="width:100%;margin-bottom: 7px;">
    <v-layout row wrap>
      <v-flex xs12>
          <div style="padding:0 5px;">
            <!-- レビュー内容 -->
            <v-card-title style="padding:7px 0px 0px 0px;">
                <v-flex v-if="isOwner" xs12 style="text-align:right;">
                  <v-btn @click="onEdit" outline color="primary" small><v-icon>edit</v-icon>編集する</v-btn>
                </v-flex>
                <router-link style="text-decoration:none;color:#000;" :to="{name: 'UserTop', params: {id: post.user.uid}}">
                  <v-layout row wrap>
                    <v-flex style="position:relative;text-align:left;">
                      <v-avatar size="44" style="z-index:10">
                        <v-img :src="post.user.imageurl" :lazy-src="require('@/assets/img/person_icon.png')"/>
                      </v-avatar>
                      <div style="height:48px;width:48px;border-radius:24px;border:solid 2px #f44336;position:absolute;top:-2px;left:-2px"></div>
                    </v-flex>
                    <v-flex style="margin-left:12px;padding-top:6px;">
                      <v-flex class="title font-weight-bold" style="text-align:left;">
                        {{post.user.displayName | textTrim(11)}}
                      </v-flex>
                      <v-flex style="font-size:90%;color:#666;text-align:left;">
                        <span v-if="!isUpdated">{{post.timestamp | displayDate}} 投稿</span>
                        <span v-else>{{post.timestamp_entry | displayDate}} 投稿　{{post.timestamp | displayDate}} 更新</span>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </router-link>
            </v-card-title>
            <v-card-text xs12 style="text-align:left;padding:16px 0px 0px 0px;">
              <p v-html="$options.filters.changeBR(post.content)" class="content"></p>
              <v-layout row wrap>
                <v-flex xs12 v-for="(image, id) in imageurls" :key=id style="margin-bottom:2px;">
                  <v-img :src="image" min-height="200px" :lazy-src="require('@/assets/img/icon_loader.gif')"></v-img>
                </v-flex>
              </v-layout>
              <v-flex xs12 v-if="isYoutube">
                <youtube width="100%" :video-id="youtubeId" :resize=true></youtube>
              </v-flex>
              <v-flex xs12 v-if="isTwitter">
                <Tweet :id="tweetId"></Tweet>
              </v-flex>
              <v-flex xs12 v-if="post.place">
                <v-chip label outline color="primary" small><v-icon small>room</v-icon>&nbsp;{{post.place}}</v-chip>
              </v-flex>
              <p v-if="post.rating">
                <v-chip small label outline color="primary" text-color="primary">
                  辛さ：<v-icon small>star</v-icon>{{post.rating.hot}}
                </v-chip>
                <v-chip small label outline color="primary" text-color="primary">
                  味：<v-icon small>star</v-icon>{{post.rating.taste}}
                </v-chip>
              </p>
              <v-flex xs12 v-if="isURL">
                参照：<a :href='post.referURL' target='_blank'>{{post.referURL | textTrim(40)}}</a>
              </v-flex>
            </v-card-text>
            <!-- ／レビュー内容 -->
            <v-flex xs12 style="text-align:right;margin-bottom:16px;">
              <v-btn icon small color="primary" flat @click="$emit('onCommentIcon')"><v-icon>chat_bubble_outline</v-icon>
                <span v-if="post.commentCount">{{post.commentCount}}</span>
              </v-btn>
              <v-btn icon small color="primary" flat @click="onLike">
                <v-icon v-if="isLike">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>          
                {{post.likes.length}}
              </v-btn>
            </v-flex>
          <!-- レビュー対象の食品情報 -->
          <food-card-min
            v-if="showFood"  
            :name="post.food.name"
            :imageurl="foodImageUrl"
            @onFoodCardMinClick="onFoodCardMinClick"
            style="margin-bottom:16px;"
          ></food-card-min>
          <!-- ／レビュー対象の食品情報 -->
          <!-- レビュー対象の飲食店情報 -->
          <shop-card-min
            v-if="showShop"  
            :shop="post.shop"
            label="カラログした飲食店"
            @onClick="$router.push({name: 'ShopDetail', params: {id: post.shop.id}})"
            style="margin-bottom:16px;"
          ></shop-card-min>
          <!-- ／レビュー対象の飲食店情報 -->
          </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import {db} from '@/main'
import FoodCardMin from '@/components/card/FoodCardMin'
import getImageUrl from '@/assets/js/getImageUrl.js'
import {Tweet} from 'vue-tweet-embed'
import ShopCardMin from '@/components/card/ShopCardMin.vue'

export default {
  name: 'ReviewView',
  data () {
    return {
      foodImageUrl: '',
      comments: [],
      showFood: false,
      showShop: false,
      isYoutube: false,
      youtubeId: '',
      isTwitter: false,
      tweetId: '',
      isURL: false,
      isUpdated: false
    }
  },
  props: {
    post: Object,
    imageurls: Array,
    onClickPosition: {
      type: String,
      default: 'card'
    }
  },
  watch: {
    post () {
      this.init()
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    isLike () {
      return this.post.likes.includes(this.user.uid)
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    isOwner () {
      return this.user.uid === this.post.user.uid
    }
  },
  filters: {
    displayDate (value) {
      let date = new Date()
      date.setTime(value.seconds * 1000)
      return `${date.getMonth() + 1}月${date.getDate()}日 ${date.getHours()}:${date.getMinutes()}`
    },
    changeBR (v) {
      return v.replace(/\r?\n/g, '<br>')
    },
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.showFood = false
      this.showShop = false
      this.isYoutube = false
      this.youtubeId = ''
      this.isTwitter = false
      this.tweetId = ''
      this.isURL = false
      this.isUpdated = false
      this.getFoodImageUrl()
      // this.refreshComment()
      if (this.post.mode === 'food' || this.post.mode === 'free') {
        this.showFood = true
      } else if (this.post.mode === 'shop') {
        this.showShop = true
      }
      if (this.post.timestamp_entry.seconds < this.post.timestamp.seconds) {
        this.isUpdated = true
      }

      if (this.onClickPosition === 'comment') {
        let target = document.getElementById('commentForm')
        this.$SmoothScroll(target, 500, undefined, undefined, 'y')
      }
      if (this.post.referURL) {
        // youtube対応
        let url = this.post.referURL
        let p1 = 'https://www.youtube.com/watch?v='
        let p2 = 'https://youtu.be/'
        if (url.indexOf(p1) !== -1) {
          let id = url.split('v=')[1]
          this.isYoutube = true
          this.youtubeId = id
        } else if (url.indexOf(p2) !== -1) {
          let id = url.split('be/')[1]
          this.isYoutube = true
          this.youtubeId = id
        }

        // Twitter対応
        url = this.post.referURL
        p1 = 'https://twitter.com/'
        if (url.indexOf(p1) !== -1) {
          let id = url.split('/status/')[1]
          this.isTwitter = true
          this.tweetId = id
        }

        if (this.isYoutube || this.isTwitter) {
          // youtubeまたはtwitter
        } else {
          this.isURL = true
        }
      }
    },
    getFoodImageUrl () {
      if (this.post.food) {
        this.foodImageUrl = getImageUrl.get('food_thumbs', this.post.food.id, this.post.food.imageurl)
      }
    },
    onCardClick () {
      this.$emit('onReviewCardClick', this.post, this.imageurls)
    },
    // async refreshComment () {
    //   let response = await db.collection('post').doc(this.post.id).collection('comment').orderBy('timestamp', 'desc').get()
    //   this.comments = []
    //   response.forEach((doc) => {
    //     let comment = doc.data()
    //     comment.id = doc.id
    //     this.comments.push(comment)
    //   })
    // },
    onFoodCardMinClick () {
      this.$router.push({name: 'searchFoodDetail', params: {id: this.post.food.id}})
    },
    onLike () {
      if (!this.isLogin) {
        let message = {
          group: 'messageBottom',
          type: 'warning',
          title: 'ログインが必要です',
          text: 'ログインしていいねしよう！'
        }
        this.$emit('onMessage', message)
        return
      }
      if (this.isLike) {
        // いいね済⇒いいね削除
        return
        // let index  = this.post.likes.findIndex(t => t === this.user.uid)
        // this.post.likes.splice(index, 1)
        // db.collection('post').doc(this.post.id).update({
        //   'likes': firebase.firestore.FieldValue.arrayRemove(this.user.uid)
        // })
      } else {
        // いいね追加
        this.post.likes.push(this.user.uid)
        db.collection('post').doc(this.post.id).update({
          'likes': firebase.firestore.FieldValue.arrayUnion(this.user.uid)
        })
      }
    },
    onEdit () {
      this.$router.push({name: 'reviewEdit', params: {id: this.post.id}})
    }
  },
  components: {
    FoodCardMin,
    ShopCardMin,
    Tweet
  }
}
</script>

<style>
  .VueCarousel-dot--active {
    background-color: #f44336 !important;
  }
  .content {
    font-weight: bold;
    font-size: 11pt;
  }
</style>